import React from "react";

export default function QuoteIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 225 225" xmlns="http://www.w3.org/2000/svg" fill="currentColor" {...props}>
      {/* Handbag with matching handle */}
      <path d="M175.86 57.44l11.73 126.61c2.27 14.64-6.35 23.11-20.99 24.21-36.51 2.76-76.68-2.15-113.58-.03-13.56-2.04-21.35-10.46-19.07-24.18l11.73-126.61h21.04l1.47 1.42v19.91c0 3.09 9.79 3.09 9.79 0v-19.91c.86-1.35 1.95-1.31 3.38-1.47 12-1.36 46.82-1.36 58.82 0 1.42.16 2.52.12 3.38 1.47v19.91c0 3.09 9.79 3.09 9.79 0v-19.91l1.47-1.42h21.04Z" />
      {/* Curved handle (bag strap) */}
      <path d="M144 43h-66c3.16-43.68 64.51-43.58 66 0Z" fill="currentColor" />
      {/* Q Letter inside the bag */}
      <text
        x="52"
        y="191"
        fontFamily="Arial Rounded MT Bold, ArialRoundedMTBold, sans-serif"
        fontSize="145"
        className="dark:fill-zinc-800 fill-white"
      >
        Q
      </text>
    </svg>
  );
}
